import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useMemo, useState, } from 'react';
import theme from '../../styles/theme';
import { RadioInputStateContext } from '../../utils/InputStateContext';
import RadioIcon from '../RadioIcon/RadioIcon';
const descriptionStyles = css `
  ${theme.typeStyles.bodyMediumStyles}
  display: block;
`;
const inputStyles = css `
  clip: rect(0, 0, 0, 0);
  position: absolute;
`;
const labelStyles = css `
  ${theme.typeStyles.titleMediumStyles}
  display: block;
`;
const defaultProps = {
    onChange: () => { },
};
const RadioOption = ({ ariaChecked, ariaDescribedBy, ariaLabel, ariaLabelledBy, description, disabled, id, isChecked, label, name, onChange = defaultProps.onChange, value, }) => {
    const [isHovering, setIsHovering,] = useState(false);
    const onPointerEnter = useCallback(() => {
        setIsHovering(true);
    }, []);
    const onPointerLeave = useCallback(() => {
        setIsHovering(false);
    }, []);
    const providerValue = useMemo(() => ({
        isHovering,
    }), [
        isHovering,
    ]);
    const descriptionComponent = useMemo(() => (description
        ? (_jsx("span", Object.assign({ css: descriptionStyles }, { children: description })))
        : null), [
        description,
    ]);
    const ariaLabelString = useMemo(() => (ariaLabel
        ? ariaLabel
        : (typeof label === 'string'
            ? label
            : undefined)), [
        ariaLabel,
        label,
    ]);
    const labelContainerStyles = useMemo(() => (css `
        ${theme.typeStyles.bodyMediumStyles}
        ${disabled && css `
          color: ${isChecked ? theme.colors.gray600 : theme.colors.gray500};
        `}
        margin-left: ${theme.spacing.x3};
      `), [
        disabled,
        isChecked,
    ]);
    const optionStyles = useMemo(() => (css `
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-between;
      `), []);
    const radioContainerStyles = useMemo(() => (css `
        display: flex;
        align-items: flex-start;

        ${!disabled && css `
          cursor: pointer;
        `}
      `), [
        disabled,
    ]);
    return (_jsx("div", Object.assign({ css: optionStyles }, { children: _jsxs("label", Object.assign({ css: radioContainerStyles, htmlFor: id, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave }, { children: [_jsx("input", { "aria-checked": ariaChecked, "aria-describedby": ariaDescribedBy, "aria-label": ariaLabelString, "aria-labelledby": ariaLabelledBy, css: inputStyles, defaultChecked: isChecked, disabled: disabled, id: id, name: name, onChange: onChange, type: "radio", value: value }), _jsx(RadioInputStateContext.Provider, Object.assign({ value: providerValue }, { children: _jsx(RadioIcon, { checked: isChecked, disabled: disabled }) })), _jsxs("span", Object.assign({ css: labelContainerStyles }, { children: [label
                            && (_jsx("span", Object.assign({ css: labelStyles }, { children: label }))), descriptionComponent] }))] })) })));
};
const MemoizedRadioOption = memo(RadioOption);
export { MemoizedRadioOption as RadioOption };
// MC-1068 Temporary hack for Storybook.
export default RadioOption;
